import moment from 'moment'

export default {
  data() {
    return {
      loader: false,
      exportLoader: false,
      totalCount: 0,
      currentPage: 1,
      perPage: 25,
      users: [],
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      searchUser: [],
      attendanceStatus: [],
      is_active: 'active',
      activeBtn: null,
      payload: {},
      reports: [],
    }
  },

  computed: {
    filterUserOptions() {
      return this.sortedEmpIdUser(this.users)
    },

    attendanceStatusList() {
      return [
        { label: 'Late Arrival', value: 'late' },
        { label: 'Work From Home', value: 'wfh' },
        { label: 'On Leave', value: 'leave' },
      ]
    },

    tableFields() {
      return [
        { key: 'employee_id', label: 'Emp ID', sortable: true, thStyle: { minWidth: '150px' } },
        { key: 'employee_name', label: 'Employee', sortable: true, thStyle: { minWidth: '200px' } },
        { key: 'date', label: 'Date', sortable: true, thStyle: { minWidth: '150px' } },
        { key: 'first_in', label: 'First In', sortable: true, thStyle: { minWidth: '130px' } },
        { key: 'last_out', label: 'Last Out', sortable: true, thStyle: { minWidth: '130px' } },
        { key: 'total_time_in', label: 'Total Time In', sortable: true, thStyle: { minWidth: '130px' } },
        { key: 'total_time_out', label: 'Total Time Out', sortable: true, thStyle: { minWidth: '130px' } },
        { key: 'track_first_in', label: 'Track First In', sortable: true, thStyle: { minWidth: '130px' } },
        { key: 'track_last_out', label: 'Track Last Out', sortable: true, thStyle: { minWidth: '130px' } },
        { key: 'track_total_time_in', label: 'Track Time In', sortable: true, thStyle: { minWidth: '130px' } },
        { key: 'track_total_time_out', label: 'Track Time Out', sortable: true, thStyle: { minWidth: '130px' } },
        { key: 'manage_by_user', label: 'Managed By', sortable: false, thStyle: { minWidth: '200px' } },
        { key: 'reporting_to_user', label: 'Reporting To', sortable: false, thStyle: { minWidth: '200px' } },
        { key: 'remarks', label: 'Remarks', sortable: false, thStyle: { minWidth: '180px' } },
        { key: 'action', label: 'Action', sortable: false, thStyle: { minWidth: '100px', textAlign: 'center' } },
      ]
    },
  },
  watch: {
    currentPage(val) {
      if (val) this.getAclSummaryLogs()
    },
    perPage() {
      if (this.currentPage === 1) {
        this.getAclSummaryLogs()
      } else {
        this.currentPage = 1
      }
    },
    is_active() {
      this.searchUser = []
      this.userList()
    },
  },

  mounted() {
    const queryParams = this.$route.query

    if (queryParams && Object.keys(queryParams).length > 0) {
      if (queryParams.is_active) this.is_active = queryParams.is_active
      if (queryParams.searchUser) {
        this.searchUser = queryParams.searchUser.split(',').filter(Boolean)
      }
      if (queryParams.attendanceStatus) {
        this.attendanceStatus = queryParams.attendanceStatus.split(',').filter(Boolean)
      }
      this.startDate = queryParams.startDate || moment().format('YYYY-MM-DD')
      this.endDate = queryParams.endDate || moment().format('YYYY-MM-DD')
      if (queryParams.active) this.activeBtn = queryParams.active
      if (queryParams.perPage) this.perPage = Number(queryParams.perPage)
      if (queryParams.currentPage) this.currentPage = Number(queryParams.currentPage)
    }

    this.getAclSummaryLogs()
    this.userList()
  },

  methods: {
    async userList() {
      const input = {
        sort_field: 'name',
        sort_order: 'asc',
        include_system_users: true,
        is_active:
          this.is_active && this.is_active !== 'all_data'
            ? this.is_active === 'active'
            : '',
      }
      const response = await this.getHTTPPostResponse(
        'admin/master/user/active-inactive-userlist',
        input,
        false,
      )
      if (response && response.data) {
        const { data } = response
        this.users = data.users
      }
    },

    updateDate(obj) {
      this.startDate = obj?.startDate || null
      this.endDate = obj?.endDate || null
      this.activeBtn = obj?.active || null
      this.currentPage = 1
      this.getAclSummaryLogs()
    },

    applyFilter() {
      this.currentPage = 1
      this.getAclSummaryLogs()
    },

    clearFilter() {
      this.startDate = moment().format('YYYY-MM-DD')
      this.endDate = moment().format('YYYY-MM-DD')
      this.searchUser = []
      this.attendanceStatus = []
      this.is_active = 'active'
      this.activeBtn = null
      this.currentPage = 1
      this.perPage = 25
      this.reports = []
      this.getAclSummaryLogs()
    },

    resetFilterState() {
      this.startDate = moment().format('YYYY-MM-DD')
      this.endDate = moment().format('YYYY-MM-DD')
      this.searchUser = []
      this.attendanceStatus = []
      this.is_active = 'active'
      this.activeBtn = null
      this.currentPage = 1
      this.perPage = 25
    },

    updateQueryParams() {
      const query = this.getQueryParams();
      // Push the query parameters to the route
      this.routeQueryUpdate(query);
    },

    getQueryParams() {
      const queryParams = {
        startDate: this.startDate,
        endDate: this.endDate,
        searchUser: this.searchUser.join(",") ?? null,
        attendanceStatus: this.attendanceStatus.join(",") ?? null,
        is_active: this.is_active,
        active: this.activeBtn,
        perPage: this.perPage,
        currentPage: this.currentPage,
      }

      // Filter out null or empty values from the query object
      return Object.keys(queryParams).reduce((acc, key) => {
        if (queryParams[key]) acc[key] = queryParams[key]
        return acc;
      }, {});
    },

    async getAclSummaryLogs() {
      this.loader = true
      this.updateQueryParams()
      const input = {
        page: this.currentPage,
        per_page: this.perPage,
        start_date: this.startDate,
        is_system_user:true,
        end_date: this.endDate,
        user_ids: this.searchUser,
        attendance_status: this.attendanceStatus,
        is_active: this.is_active && this.is_active !== 'all_data'
          ? this.is_active === 'active'
          : '',
      }

      this.payload = input

      try {
        const response = await this.getHTTPPostResponse(
          'admin/master/reports/acl-summary-logs',
          input,
          false,
        )

        if (response && response.status === 200) {
          const { data } = response
          this.totalCount = data.count || 0
          this.reports = data.acl_summary_logs || []
        } else {
          this.reports = []
          this.totalCount = 0
        }
      } catch (error) {
        console.error('Error fetching ACL summary logs:', error)
        this.reports = []
        this.totalCount = 0
      } finally {
        this.loader = false
      }
    },

    /**
     * Returns inline style for the row background color based on flags.
     * Using style attr directly bypasses CSS specificity issues with Bootstrap td bg.
     */
    rowStyle(item) {
      if (!item) return {}
      if (item.is_late) return { style: 'background-color: #fff1f1 !important' }
      if (item.is_wfh) return { style: 'background-color: #e8f0fe !important' }
      if (item.auto_leave_applied) return { style: 'background-color: #ffcccc !important' } // Auto Leave applied indicator
      if (item.is_on_leave) return { style: 'background-color: #fffbea !important' }
      return {}
    },

    /**
     * Returns the dot color class based on flag priority: late > wfh > on_leave
     */
    statusDotClass(item) {
      if (item.auto_leave_applied) return 'dot-leave'
      if (item.is_late) return 'dot-late'
      if (item.is_wfh) return 'dot-wfh'
      if (item.is_on_leave) return 'dot-leave'
      return ''
    },

    /**
     * Returns tooltip text for the status dot
     */
    statusTooltip(item) {
      if (item.auto_leave_applied) return 'Auto-Applied Leave'
      if (item.is_late) return 'Late Arrival'
      if (item.is_wfh) return 'Work From Home'
      if (item.is_on_leave) return 'On Leave'
      return ''
    },

    /**
     * Applies a highlight class to table rows based on attendance flags.
     * Priority: is_late > is_wfh > is_on_leave
     */
    rowClass(item) {
      if (!item) return ''
      let classes = ''
      
      if (item.auto_leave_applied) {
        classes += ' acl-row-leave'
      } else if (item.is_late) {
        classes += ' acl-row-late'
      } else if (item.is_wfh) {
        classes += ' acl-row-wfh'
      } else if (item.is_on_leave) {
        classes += ' acl-row-leave'
      }
      
      return classes.trim()
    },

    handleRowClick(row) {
      if (!row || !row.employee_id) return

      this.$router.push({
        name: 'aclAccessLogReport',
        query: {
          searchUser: row.employee_id,
          startDate: moment(row.date).format('YYYY-MM-DD'),
          endDate: moment(row.date).format('YYYY-MM-DD'),
        }
      })
    },

    back() {
      this.$router.back()
    },

    confirmationFunction(type) {
      this.generateExportReport(type)
    },

    async generateExportReport(type) {
      this.exportLoader = true

      const input = {
        start_date: this.startDate,
        end_date: this.endDate,
        export_type: type,
        user_ids: this.searchUser,
        attendance_status: this.attendanceStatus,
        is_active: this.is_active && this.is_active !== 'all_data'
          ? this.is_active === 'active'
          : '',
      }

      const fileName = type === 'PDF' ? 'AclSummaryReport.pdf' : 'AclSummaryReport.xlsx'

      try {
        const response = await this.$axios({
          url: `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_VERSION}/admin/master/reports/acl-summary-logs`,
          method: 'POST',
          data: input,
          responseType: 'blob',
        })

        const blob = new Blob([response.data], {
          type: type === 'PDF' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })

        const fileURL = window.URL.createObjectURL(blob)
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', fileName)
        document.body.appendChild(fileLink)
        fileLink.click()
        document.body.removeChild(fileLink)
        window.URL.revokeObjectURL(fileURL)
      } catch (error) {
        console.error('Error exporting data:', error)
      } finally {
        this.exportLoader = false
      }
    },

    sortedEmpIdUser(userList) {
      const users = [...userList]
      users.sort((a, b) => {
        const nameA = `${a.name} ${a.last_name}`.toUpperCase()
        const nameB = `${b.name} ${b.last_name}`.toUpperCase()
        return nameA.localeCompare(nameB)
      })

      return users.map(element => ({
        value: element.id,
        label: `${element.full_name ? element.full_name : element.name}`,
        emp_id: element.emp_id,
      }))
    },

    formatExtraTime(minutes) {
      if (!minutes || minutes <= 0) return ''
      const h = Math.floor(minutes / 60)
      const m = Math.floor(minutes % 60)
      let str = '+ '
      if (h > 0) str += `${h} hours `
      if (m > 0 || h === 0) str += `${m} mins`
      return str.trim()
    },
  },
}
